import { gql } from 'apollo-angular';

export const EndTutorialDocument = gql`
  mutation endTutorial($tutorialEnded: Boolean!) {
    endTutorial(tutorialEnded: $tutorialEnded)
  }
`;
